import { render, staticRenderFns } from "./input-checkbox-group.vue?vue&type=template&id=06201832&"
import script from "./input-checkbox-group.vue?vue&type=script&lang=js&"
export * from "./input-checkbox-group.vue?vue&type=script&lang=js&"
import style0 from "./input-checkbox-group.vue?vue&type=style&index=0&id=06201832&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports